<div class="container" style="background-color: #ccc">
  <!--<div class="container" [ngStyle]="{ 'background-color': '#'+colorMain }">-->
  <div class="wrap2">
    <div id="seachform">
      <form #formSearch="ngForm" novalidate="">
        <table border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td class="collaps" [ngStyle]="{ 'display': !companyService.getFilterByName('dates')?'none':'content'}">
              <mat-datepicker-toggle matIconSuffix [for]="pickerfrom" class="pickerButton"></mat-datepicker-toggle>
              <input matInput [matDatepicker]="pickerfrom" id="pickerFrom" placeholder="Date From:"
                [formControl]="dateFrom" [min]="minDateFrom" (ngModelChange)="setDateTo($event)" readonly (click)="pickerfrom.open()">
              <mat-datepicker #pickerfrom></mat-datepicker>
            </td>
            <td class="collaps" [ngStyle]="{ 'display': !companyService.getFilterByName('dates')?'none':'content'}">
              <mat-datepicker-toggle matIconSuffix [for]="pickerto" class="pickerButton"></mat-datepicker-toggle>
              <input matInput [matDatepicker]="pickerto" id="pickerTo" placeholder="Date To:" [formControl]="dateTo"
                [min]="minDateTo" [max]="maxDateTo" readonly (click)="pickerto.open()">
              <mat-datepicker #pickerto></mat-datepicker>
              <!--<select [(ngModel)]="buscador.fecha.month" id="seldate" name="fecha" required>
                <option *ngFor="let mes of listMonth" value="{{ mes }}">{{ mes }}</option>
                <option value="All" style="font-weight: bold;">All Months</option>
              </select>
              <select id="selyear" [(ngModel)]="buscador.fecha.year" name="selyear" (change)="changeYear()">
                <option *ngFor="let year of listYears" value="{{ year }}">{{ year }}</option>
              </select>-->
            </td>
            <td class="collaps" [ngStyle]="{ 'display': !companyService.getFilterByName('passenger')?'none':'content'}">
              <select [(ngModel)]="buscador.pasajeros" id="selpax" name="paxs" required
                (ngModelChange)="onChangePassenger()">
                <option value="charterOnly" *ngIf="dataCompany?.visibleCharterOnly">
                  PRIVATE CHARTER</option>
                <option *ngFor="let pax of cataloguePax" value="{{pax.code}}" style="text-transform: uppercase;">
                  {{pax.description}}</option>
                <option value="charterOnly" *ngIf="dataCompany?.visibleCharterOnly">
                  PRIVATE CHARTER</option>
              </select>
            </td>
            <td class="collaps" [ngStyle]="{ 'display': !companyService.getFilterByName('length')?'none':'content'}">
              <!--<select [(ngModel)]="buscador.dias" id="sellength" name="dias" required>
                <option *ngFor="let itineray of catalogueItinerary" value="{{itineray.code}}">{{itineray.description}}
                </option>
              </select>-->
              <mat-select #lengthCruises [formControl]="selectedLengthCruises" multiple id="sellength" name="dias"
                required placeholder="Cruise lengths">
                <mat-select-trigger>{{selectedLengthCruises.value.includes('All')?'All':selectedLengthCruises.value+'
                  Days'}}</mat-select-trigger>
                <mat-option #lengthCruise class="searchform-select promotions-option"
                  *ngFor="let itineray of catalogueItinerary" [value]="itineray.code"
                  (click)="selectedLenghtCruiseOption(lengthCruise)">{{itineray.description}}
                </mat-option>
                <div style="text-align: -webkit-right;">
                  <a class="inq"
                    style="color: white; cursor: pointer; text-decoration: none; margin: 0 !important; width:fit-content;"
                    [ngStyle]="{ 'background-color': colorSecundario }"
                    (click)="multiselectClose('lengthCruises')">CLOSE</a>
                </div>
              </mat-select>
            </td>
            <td class="collaps"
              [ngStyle]="{ 'display': !companyService.getFilterByName('boat') && !companyService.getFilterByName('category') ?'none':'content'}">
              <select [(ngModel)]="buscador.barco" name="barco" id="selboat" required>
                <optgroup label="Category" *ngIf="companyService.getFilterByName('category')">
                  <option *ngFor="let cat of listCategories" value="{{ cat.valueCategory }}">{{ cat.nameCategory }} {{
                    cat.startCategory }}</option>
                </optgroup>
                <optgroup label="Boats" *ngIf="companyService.getFilterByName('boat')">
                  <option *ngFor="let boat of listBoats" value="{{ boat.nameBoat }}">{{ boat.nameBoat }} {{
                    boat.startBoat }}</option>
                </optgroup>
                <option value="All" style="font-weight: bold;">All Cruises</option>
              </select>
            </td>
            <td id="button-space">
              <a (click)="buscarSalidas(formSearch)" type="submit" name="btnSearch" id="btnSearch" class="btn"
                style="color: white; cursor: pointer; width: 100%;"
                [ngStyle]="{ 'background-color': colorSecundario }">Find your Cruise!</a>
              <!--              <a href="javascript:;" class="btn" style="background-color:#aa0000; color:#fff;">Find your Cruise!</a>-->
            </td>
          </tr>
          <tr *ngIf="!visibleAdvanceSearch">
            <td class="collaps" colspan="5" style="padding-top: 10px;">
              <a href="javascript:void()" (click)="visibleAdvanceSearch=!visibleAdvanceSearch">Advance search</a>
            </td>
          </tr>
          <tr *ngIf="visibleAdvanceSearch ">
            <td class="collaps">
              <mat-select #promotions [formControl]="selectedPromotions" multiple placeholder="Promotions"
                (selectionChange)="onChangePromotions()"
                [ngStyle]="{ 'visible': companyService.getFilterByName('promotions')?'hidden':'inherit'}"
                panelClass="myPanelClass" style="background-color: white;padding-top: 5px;" class="promotions-select">
                <mat-option *ngFor="let promotion of promotionsList" [value]="promotion.value"
                  class="promotions-option">{{promotion.label}}
                </mat-option>
                <mat-option [value]="CHARTER_PROMO" *ngIf="dataCompany?.visibleCharterOnly"
                  class="promotions-option">CHARTER
                </mat-option>
                <div style="text-align: -webkit-right;">
                  <a class="inq"
                    style="color: white; cursor: pointer; text-decoration: none; margin: 0 !important; width:fit-content;"
                    [ngStyle]="{ 'background-color': colorSecundario }"
                    (click)="multiselectClose('promotions')">CLOSE</a>
                </div>
              </mat-select>
            </td>
            <td class="collaps" *ngIf="dataCompany?.visibleGroupsOnly">
              <div class="optionsdiv">
                <label for="groupsOnly"
                  style="font-family: 'Roboto Condensed', sans-serif;font-size: 14px;color: #666;">Groups Only</label>
                <input type="checkbox" style="cursor: pointer;" [ngModel]="buscador.groupsOnly"
                  (change)="buscador.groupsOnly = !buscador.groupsOnly" name="groupsOnly" />
              </div>
            </td>
            <!--

              <td class="collaps">
                <div class="optionsdiv">

                  <label for="charterOnly"
                    style="font-family: 'Roboto Condensed', sans-serif;font-size: 14px;color: #666;">Charter Only</label>
                  <input type="checkbox" style="cursor: pointer;" [ngModel]="buscador.charterOnly"
                    (change)="buscador.charterOnly = !buscador.charterOnly" name="charterOnly" />
                </div>
              </td>
            -->
            <td
              [ngStyle]="{ 'visible': companyService.getFilterByName('promotions')|| dataCompany?.visibleGroupsOnly?'hidden':'inherit'}">
              <div class="show-less">
                <a href="javascript:void()" (click)="visibleAdvanceSearch=!visibleAdvanceSearch">Hide advance search</a>
              </div>
            </td>
          </tr>

        </table>
        <div class="errors">
          <span id="errorBarco"></span>
          <span id="errorDias"></span>
          <span id="errorfecha"></span>
          <span id="errorpax"></span>
          <span id="errorcriteria" *ngIf="textoMensajeBusqueda">-- Please, complete the criteria for search. --</span>
        </div>
      </form>
    </div>
  </div>
</div>